module.exports = __webpack_public_path__ + "static/img/zl_btn1.4a4310b.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/home/pc/role3/control/zl_btn1.png
// module id = L18l
// module chunks = 7